var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgJoystream(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "100 142 200 242",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M232 154.004H153V181.311H201.19V293.659C201.19 302.632 195.66 310.434 187.365 313.945L168.01 321.356L176.305 351.004L205.535 339.691C215.41 335.79 223.705 328.378 228.05 319.016C230.815 313.554 232 307.313 232 301.461V154.004Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJoystream);
export default __webpack_public_path__ + "static/media/joystream.d53d788563e64a4dcb221137fd557368.svg";
export { ForwardRef as ReactComponent };